import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { PublicLeadPreApprovedUrl } from './ApiEndPoints';
import { Lead } from 'pages/leadGen/LeadGenInterface';
import { LOCAL_STORAGE_KEYS } from 'constants/CommonConstants';
import { handleApiError } from './CommonModuleState';

const initialState: {
  leadCreationFormData: {
    message?: string | Lead;
    success?: boolean;
  };
  showSuccessPage: boolean;
  loading: boolean;
} = {
  leadCreationFormData: {},
  loading: false,
  showSuccessPage: false,
};

const VITE_LEAD_CREATION_TYPE_ID = import.meta.env.VITE_LEAD_CREATION_TYPE_ID;

export const postLeadCreation = createAsyncThunk(
  'leadCreation/postLeadCreation',
  async (requestData: { data: Lead; leadTypeID: string }) => {
    try {
      const draftLeadId = await localStorage.getItem(LOCAL_STORAGE_KEYS.draftLeadId);
      let payload = requestData?.data;
      if (draftLeadId) {
        payload = {
          ...requestData?.data,
          draftLeadId,
        };
      }
      const response = await axios.post(`${PublicLeadPreApprovedUrl}${requestData.leadTypeID}`, payload);

      return response.data;
    } catch (error: unknown) {
      const errorMessage = handleApiError(error);
      throw new Error(errorMessage);
    }
  }
);

export const leadCreationState = createSlice({
  name: 'leadCreation',
  initialState,
  reducers: {
    clearLeadCreation: (state) => {
      return {
        ...state,
        leadCreationFormData: initialState.leadCreationFormData,
      };
    },
    showSuccessPageAction: (state, action) => {
      return {
        ...state,
        showSuccessPage: action.payload.showSuccessPage,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postLeadCreation.pending, (state) => {
        state.loading = true;
      })
      .addCase(postLeadCreation.fulfilled, (state, action) => {
        (action.payload?.data?.draftLeadId || action.payload?.data?._id) &&
          localStorage.setItem(
            LOCAL_STORAGE_KEYS.draftLeadId,
            action.payload?.data?.draftLeadId || action.payload?.data?._id
          );
        state.loading = false;
        state.leadCreationFormData = action.payload;
      })
      .addCase(postLeadCreation.rejected, (state, action) => {
        state.loading = false;
        state.leadCreationFormData = {
          message: action.error.message,
          success: false,
        };
      });
  },
});

export const { clearLeadCreation } = leadCreationState.actions;

export default leadCreationState.reducer;
